/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Line_Assignments_SinceInputs */

const fr_line_assignments_since = /** @type {(inputs: Line_Assignments_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`depuis`)
};

const en_line_assignments_since = /** @type {(inputs: Line_Assignments_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`since`)
};

/**
* | output |
* | --- |
* | "since" |
*
* @param {Line_Assignments_SinceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const line_assignments_since = /** @type {((inputs?: Line_Assignments_SinceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Line_Assignments_SinceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_line_assignments_since(inputs)
	return en_line_assignments_since(inputs)
});